import { render, staticRenderFns } from "./AuxiliaryInvent.vue?vue&type=template&id=50a791ec&scoped=true&"
import script from "./AuxiliaryInvent.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryInvent.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryInvent.vue?vue&type=style&index=0&id=50a791ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a791ec",
  null
  
)

export default component.exports